import { CSSProperties, useCallback, useEffect, useRef } from 'react';

import LottieView from 'lottie-react-native';
import { ViewStyle } from 'react-native';

import { StaticImages, useStaticLottieUri } from 'components/picture/static-image';
import { useLottieSource } from 'utils/lottie/use-lottie-source';

// Only use common props values here. Don't use specific platform styles
const commonStyles: ViewStyle | CSSProperties = {
  left: -35,
  bottom: -50,
  height: 170,
  width: 170,
  zIndex: 1,
  position: 'absolute',
};

export const ConfettiAnimation = ({
  isActive = true,
  onAnimationFinish,
  onAnimationLoop,
  loop = false,
}: {
  isActive?: boolean;
  onAnimationFinish?: () => void;
  onAnimationLoop?: () => void;
  loop?: boolean;
}) => {
  const uri = useStaticLottieUri(StaticImages.ConfettiRewardsButton);
  const completionCalledRef = useRef(false);
  const { source, error } = useLottieSource({
    source: uri ? { uri } : undefined,
    surface: 'rewards_confetti',
  });

  const finishOnce = useCallback(() => {
    if (completionCalledRef.current) {
      return;
    }
    completionCalledRef.current = true;
    onAnimationFinish?.();
  }, [onAnimationFinish]);

  useEffect(() => {
    completionCalledRef.current = false;
  }, [isActive, uri]);

  useEffect(() => {
    if (isActive && error) {
      finishOnce();
    }
  }, [error, finishOnce, isActive]);

  if (!isActive || !source) {
    return null;
  }

  return (
    <LottieView
      key={uri}
      source={source}
      loop={loop}
      resizeMode="cover"
      autoPlay={true}
      style={commonStyles as ViewStyle}
      webStyle={commonStyles as CSSProperties}
      onAnimationLoop={onAnimationLoop}
      onAnimationFinish={finishOnce}
    />
  );
};
